<ng-template [ngIf]="isEdit">
    <div class="modal-header">
        <p class="modal-title"><strong>Amend activity</strong></p>
         <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

    </div>

    <div class="alert alert-warning m-0">
        Changes to this activity will affect the following countries:
        <br />
        {{getSharedCountries()}}
    </div>

    <div class="modal-body p-3">
        <form [formGroup]="amendForm" class="d-flex justify-content-start flex-column">
            <div class="w-100 mb-2">
                <label>Order *</label>
                <input type="number" class="w-35 form-control form-control-sm" formControlName="order" />
            </div>

            <div class="w-100 mb-2">
                <label>Header *</label>
                <textarea class="w-100 form-control form-control-sm" formControlName="header"></textarea>
            </div>

            <div class="w-100 mb-2">
                <label>Description *</label>
                <textarea class="w-100 form-control form-control-sm" formControlName="description"></textarea>
            </div>

            <div class="w-100 mb-2">
                <label for="active">
                    <input id="active" type="checkbox" formControlName="isActive" />
                    Active
                </label>
            </div>

        </form>
    </div>


    <div class="text-center p-3">
        <button class="btn btn-outline-primary me-2" (click)="modal.dismiss()">Close</button>
        <button (click)="onSave()" eosDebounce [disabled]="!amendForm.valid" class="btn btn-secondary"
            type="submit">Update</button>
    </div>
</ng-template>

<ng-template [ngIf]="!isEdit">
    <div class="modal-header">
        <p class="modal-title"><strong>Create an activity</strong></p>
      <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

    </div>
    <div class="modal-body p-3">
        <form [formGroup]="createForm" class="d-flex flex-column row">
            <div class="row m-0">

                <div class="col mb-2">
                    <label>Activity type *</label>
                    <ng-select [items]="activityTypes" [closeOnSelect]="false" [multiple]="false"
                        bindLabel="displayText" bindValue="id" formControlName="activityType">
                    </ng-select>
                </div>

                <div class="col mb-2">
                    <label>Order *</label>
                    <input type="number" class="w-35 form-control form-control-sm" formControlName="order" />
                </div>
            </div>
            <div class="row m-0">
                <div class="col mb-2">
                    <label>Header *</label>
                    <textarea class="w-100 form-control form-control-sm" formControlName="header"></textarea>
                </div>
            </div>

            <div class="row m-0">
                <div class="col mb-2">
                    <label>Description *</label>
                    <textarea class="w-100 form-control form-control-sm" formControlName="description"></textarea>
                </div>
            </div>
            <div class="row m-0">
                <div class="col mb-2">
                    <label>Employee category *</label>
                    <ng-select [items]="employeeCategories" [closeOnSelect]="false" [multiple]="true"
                        bindLabel="displayText" bindValue="id" formControlName="employeeCategoryIds">
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:3">
                                <span class="ng-value-label">
                                    {{item.displayText}}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 3">
                                <span class="ng-value-label">+{{items.length - 3}}</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>

                <div class="col mb-2">
                    <label for="active">
                        Is transfer type within same office?
                    </label>
                    <ng-select [items]="yesNo" [multiple]="false" bindLabel="displayText" bindValue="value"
                        formControlName="withinSameOffice">
                    </ng-select>
                </div>
            </div>
            <div class="row m-0">
                <div class="col mb-2">
                    <label>Pre-boarding type *</label>
                    <ng-select [items]="preboardingTypes" [multiple]="false" bindLabel="displayText" bindValue="id"
                        formControlName="pbTypeId">
                    </ng-select>
                </div>

                <div class="col mb-2">
                    <label>Country *</label>
                    <ng-select [items]="countries" [closeOnSelect]="false" [multiple]="true" bindLabel="displayText"
                        bindValue="id" formControlName="countryIds">
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:3">
                                <span class="ng-value-label">
                                    {{item.displayText}}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 3">
                                <span class="ng-value-label">+{{items.length - 3}}</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>

            </div>
            <div class="row m-0">
                <div class="col mb-2">
                    <label for="active">
                        <input id="active" type="checkbox" formControlName="isActive" />
                        Active
                    </label>
                </div>
            </div>


            <!-- <div class="w-100 mb-2">
                <label>Employee category</label>
                <textarea class="w-100 form-control form-control-sm" formControlName="propertyExtensions"></textarea>
            </div> -->
            <div class="text-center p-3">
                <button class="btn btn-outline-primary me-2" (click)="modal.dismiss()">Close</button>
                <button (click)="createActivity()" eosDebounce [disabled]="!createForm.valid" class="btn btn-secondary"
                    type="submit">Create</button>
            </div>

        </form>
    </div>

</ng-template>